
import viewRelateFlow from '@/components/browse/view-relate-flow';
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'

import cusDateTime from '@/components/cusDateTime';
import selectSupply from '@/components/browse/select-supply';

export default {
name: "receipt-view",
components: {viewRelateFlow, Grid, GridItem, Popup, cusDateTime, selectSupply},
props: ['dataId', 'component'],
data() {
return {
baseDto: {flowState: 'send'},
list: [],
index: 1,
show: false,
showList: [],
isInner: false,
en: 0,
flowState: '',
}
},
methods: {
itemTab(index) {
this.index = index;
if(index === 3){
this.$emit('changeFlowInfo',true);
}else{
this.$emit('changeFlowInfo',false);
}
},
getBaseDto() {
this.$loadingShow();
this.$get('api/receiptConfirmation/' + this.dataId).then((data) => {
if (data) {
if (data.requestBase && data.requestBase.workflowNodeBase) {
this.flowState = data.requestBase.workflowNodeBase.actNodeId;
}
this.baseDto = data;
console.log(this.flowState)
}
this.$loadingHide();
}).catch((error) => {
this.$loadingHide();
});
},
valid() {
if (!this.baseDto.salesMan || this.baseDto.salesMan === undefined
|| this.baseDto.salesMan === null ) {
this.$message.error('请选择业务人员');
return false;
}
if (this.baseDto.attachment === undefined || this.baseDto.attachment.attachFile.length < 1) {
this.$message.error('附件必填');
return false;
}
return true;
},
formData() {
return this.baseDto;
},
},
mounted() {
if (this.dataId) {
this.getBaseDto()
}
this.isInner = this.$store.state.userType == 1;
},
watch: {
dataId() {
if (this.dataId) {
this.getBaseDto()
}
}
}
}



// WEBPACK FOOTER //
// ./src/page/receipt/receipt-view.vue